// extracted by mini-css-extract-plugin
module.exports = {"spotlight":"Spotlight_spotlight__1q-9c","foot":"Spotlight_foot__2ACAE","title":"Spotlight_title__3jtI2","description":"Spotlight_description__10qN_"};